import { legacyGet, legacyPost } from '../legacy-client';
import type {
  CableResponse,
  CableSpool,
  RecordCableUsageDto,
  CableUsageResponse,
  CableUsageHistoryItem,
  SuccessResponse,
} from './types';

export const legacyCableApi = {
  /**
   * Get all cable spools (global list)
   * Marks isMyOwn for current user's spools
   */
  getAll: async (): Promise<CableSpool[]> => {
    const response = await legacyGet<CableResponse>('getCable');
    return response.cable || [];
  },

  /**
   * Record cable usage (client action)
   * @param dto.buhta_id - Spool ID
   * @param dto.amount - Meters used
   * @param dto.company - Client name (for tracking)
   */
  recordUsage: (dto: RecordCableUsageDto): Promise<CableUsageResponse> =>
    legacyPost<CableUsageResponse, RecordCableUsageDto>('recordCableUsage', dto),

  /**
   * Transfer spool ownership to another user (or claim for yourself)
   * @param buhtaId - Spool ID
   * @param username - Target user's username (empty string = claim for self)
   */
  transferOwnership: (buhtaId: number, username: string): Promise<SuccessResponse> =>
    legacyGet<SuccessResponse>('setBuhtaOwner', { buhta_id: buhtaId, user: username }),

  /**
   * Get list of active users for transfer dropdown
   * Returns { username: displayName, ... }
   */
  getActiveUsers: (): Promise<Record<string, string>> =>
    legacyGet<Record<string, string>>('getActiveUsers'),

  /**
   * Get usage history for a specific spool
   * @param buhtaId - Spool ID
   * @returns Array of usage history items, newest first
   */
  getHistory: async (buhtaId: number): Promise<CableUsageHistoryItem[]> => {
    const response = await legacyGet<CableUsageHistoryItem[]>(
      'getBuhtaHistory',
      { id: buhtaId }
    );
    return response || [];
  },

  /**
   * Get all cable usage history (for history tab)
   * @param onlyMine - If true, only show current user's records
   * @returns Array of usage history items with spool names, newest first (max 50)
   */
  getAllHistory: async (onlyMine: boolean): Promise<CableUsageHistoryItem[]> => {
    const response = await legacyGet<CableUsageHistoryItem[]>(
      'getAllCableHistory',
      { onlyMine: onlyMine ? '1' : '0' }
    );
    return response || [];
  },
};
